import { type MouseEvent } from 'react';
import { MenuButton } from '../MenuButton';
import TEXT from './generated/TEXT/Workspace_ContextMenuButton';

type ContextMenuButtonProps = {
  onContextMenu: (event: MouseEvent) => void;
};

export const ContextMenuButton = ({
  onContextMenu,
}: ContextMenuButtonProps) => {
  return (
    <MenuButton
      data-dd-action-name="workspace-nav.context-menu"
      data-testid="workspace-row--menu-button"
      label={TEXT.ariaLabel}
      onClick={onContextMenu}
    />
  );
};

TEXT.DEFINE({
  ariaLabel: 'Open workspace context menu',
});
